var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoaching(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#coaching_svg__clip0_646_47136)",
    stroke: "#624DE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.957 20.45v-1.995a3.989 3.989 0 00-3.99-3.99h-6.98a3.989 3.989 0 00-3.99 3.99v1.994M8.477 10.476a3.99 3.99 0 100-7.978 3.99 3.99 0 000 7.978z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.282 3.527c0-.569.46-1.03 1.03-1.03h5.661c.569 0 1.03.461 1.03 1.03V7.13a1.03 1.03 0 01-1.03 1.03h-4.339a1.03 1.03 0 00-.856.458l-1.19 1.783a.168.168 0 01-.139.075v0a.168.168 0 01-.167-.168V3.527z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coaching_svg__clip0_646_47136"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCoaching;